import React, { FC } from 'react';
import classnames from 'classnames';

import { useBankProducts } from '../context/BankProductsContext';
import { useDatasources } from '../context/DataSourceContext';
import { useCustomVar } from '../hooks/useCustomVar';

interface IntroductionDescriptionProps {
  isTextWhite: boolean;
  textDescription: string;
}

const descriptionClasses = (isWhite: boolean): string =>
  classnames('tracking-tight font-normal break-normal mt-2', 'md:tracking-normal md:text-lg', 'lg:text-l', {
    'text-white': isWhite
  });

const IntroductionDescription: FC<IntroductionDescriptionProps> = ({ isTextWhite, textDescription }) => {
  const { contextProducts } = useBankProducts();
  const { contextDatasources } = useDatasources();
  const { resolvedText, textOpacityClass } = useCustomVar(textDescription, contextProducts, contextDatasources);

  return (
    <div className={classnames('lg:mt-8 md:mt-0 sm:mt-8 md:w-2/3')}>
      <p className={`${textOpacityClass} transition-opacity ${descriptionClasses(isTextWhite)}`}>{resolvedText}</p>
    </div>
  );
};

export default IntroductionDescription;
